export default __webpack_public_path__ + "fonts/icomoon.76b6f4fb6220888438133473b2219cf1.eot";